var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"purchase-container",attrs:{"fluid":""}},[_c('PurchaseFlow')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }